import { QueryField } from '@y42/json-schema';

export function transformCalculatedField(value: string): string {
  return value.replace(/__calculated_field__$/, '');
}

export function isCalculatedField(queryField: QueryField): boolean {
  return queryField.lowCodeString !== null;
}
